import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';
import { SingleNeed } from './SingleNeed.model';

export default interface ICurrentNeedsModel extends BaseEntity {
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    CurrentNeedsList: SingleNeed[];
    OtherAddictiveBehaviorsDescription: string;

    NeedsEducationOn: string;
    NeedsOtherEnvironmentalSupport: string;
    SkillsAndSupportsNeeds: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
}

export class CurrentNeedsModel implements ICurrentNeedsModel {
    Id: string;
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    CurrentNeedsList: SingleNeed[];
    OtherAddictiveBehaviorsDescription: string;

    NeedsEducationOn: string;
    NeedsOtherEnvironmentalSupport: string;
    SkillsAndSupportsNeeds: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.CurrentNeedsList = [];
        this.OtherAddictiveBehaviorsDescription = '';

        this.NeedsEducationOn = '';
        this.NeedsOtherEnvironmentalSupport = '';
        this.SkillsAndSupportsNeeds = '';

        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
    }
}
